import React from 'react';
import { useOfferContext } from '../../../context';
import { Gallery } from '../../../components/Gallery';
import { OfferLabelsContainer } from './OfferLabelsContainer';
import { FeatureLabelsContainer } from './FeatureLabelsContainer';
import { useApplicationContext } from '../../../../../../shared/serp/containers/ApplicationContext';
import { OfferGalleryPessimizationFlexible } from '../../../components/OfferGalleryPessimizationFlexible';

export function GalleryContainer() {
  const {
    media,
    tracking,
    offer: { moderationInfo },
  } = useOfferContext();
  const { config } = useApplicationContext();
  const [clicked, setClicked] = React.useState(false);
  const renderMediaDelay = config.get<number>('serp.gallery.renderMediaDelay') || 500;
  const isFlexibleSanctions = config.get<boolean>('Moderation.CustomSanction.NewModerationInfo.Enabled');

  const handleChangeSlide = React.useCallback(() => {
    if (!clicked) {
      tracking.trackPhotoSlideChanged();
      setClicked(true);
    }
  }, [clicked, tracking.trackPhotoSlideChanged]);

  if (isFlexibleSanctions && moderationInfo?.photoStub) {
    return <OfferGalleryPessimizationFlexible photoStub={moderationInfo.photoStub} />;
  }

  return (
    <>
      <Gallery media={media} onChangeSlide={handleChangeSlide} renderMediaDelay={renderMediaDelay} />
      <OfferLabelsContainer />
      <FeatureLabelsContainer />
    </>
  );
}
